export default __webpack_public_path__ + "ee26c7db14170d47ecdb4eaaecdf8e35.png";